import useSegmentManager from "@/hooks/useSegmentManager";

/** Recalculate segment income when event production gate flips (event start/end) */
export function recalcSegmentsForEventProduction(): void {
	try {
		const sm = useSegmentManager();
		sm.markAllSegmentsAsDirty();
		sm.run(true);
	} catch {
		// SegmentManager not initialized yet — initial load marks all segments dirty.
	}
}
